import React from 'react';
import type { CustomBriefOverallVerdict } from '../../../../types/siteRag';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { EditorialBadge, type EditorialBadgeTone } from '../../report/editorial';

/**
 * Overall-verdict badge — themed editorial outline pill.
 *
 * Was: filled `bg-green-500/15 / bg-amber-500/15 / bg-red-500/15`
 * pills reading APP Tailwind tokens (ignored the active ReportTheme).
 * Now: <EditorialBadge variant="outline"> whose ink + hairline border
 * read roleColor(theme,<tone>), so the verdict follows the report
 * preset (Journal/Review/…) like the rest of the editorial body.
 * The verdict→tone map preserves the original semantic colours
 * (proceed=positive/green, caution=warning/amber, stop=negative/red,
 * inconclusive=neutral/slate).
 */
const VERDICT_TONE: Record<CustomBriefOverallVerdict, EditorialBadgeTone> = {
  PROCEED: 'positive',
  CAUTION: 'warning',
  STOP: 'negative',
  INCONCLUSIVE: 'neutral',
};

interface Props {
  verdict: CustomBriefOverallVerdict;
}

export const VerdictBadge: React.FC<Props> = ({ verdict }) => {
  const theme = useEffectiveReportTheme();
  return (
    <span className="inline-flex" data-testid="custom-brief-verdict-badge">
      <EditorialBadge theme={theme} tone={VERDICT_TONE[verdict] ?? 'neutral'} variant="outline">
        {verdict.replace('_', ' ')}
      </EditorialBadge>
    </span>
  );
};
